import { Component, HostListener, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ResultpagesharedService } from '../../share/service/resultpageshared.service';
import { NavigationService } from '../../share/service/navigation.service';

@Component({
  selector: 'app-resultpage',
  templateUrl: './resultpage.component.html',
  styleUrls: ['./resultpage.component.scss'],
})
export class ResultpageComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostListener('window:scroll', ['$event']) onScroll() {
    if (this.sharedResultService.loading) {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        document.querySelector<HTMLElement>('.loader-line').style.position =
          'fixed';
      } else {
        document.querySelector<HTMLElement>('.loader-line').style.position =
          'relative';
      }
    }
  }

  windowCouponAmount: string;

  constructor(
    public sharedResultService: ResultpagesharedService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.sharedResultService.initComponent();
    this.windowCouponAmount = window['wf_sso_coupon_amount'];
  }

  ngAfterViewInit() {
    this.navigationService.restoreScrollPosition(100);
  }

  ngOnDestroy() {
    this.sharedResultService.ngOnDestroy();
  }

  postFilter() {
    this.sharedResultService.postFilter();
  }

  postLoan() {
    this.sharedResultService.postLoan();
  }

  skipToContent(): void {
    this.navigationService.skipToMainContent();
  }
}
